import { useHistory, useLocation } from 'react-router-dom'

import qs from 'qs'
import { isEmpty } from 'rambda'


function removeEmpty<T extends Record<string, any>, K extends keyof T>(obj: T): Partial<T> {
  const objElements: Partial<T> = Object.fromEntries<T[K]>(
    Object.entries(obj)
      .filter(([ _, v ]) => {
        if (typeof v === 'boolean') {
          return true
        }
        return v && !isEmpty(v)
      })
  )
  return objElements
}

export default function useSearchParams () {
  const { replace } = useHistory()
  const { search, pathname } = useLocation()

  const setSearchParams = (value: any) => {

    const string = qs.stringify(removeEmpty(value))

    replace({
      pathname,
      search: string
    })
  }

  const getSearchParams = () => {
    const value = qs.parse(search, { 
      ignoreQueryPrefix: true,
      // Преобразовывать объекты с числовыми ключами в массивы
      parseArrays: true
    })
    return value
  }

  return {
    setSearchParams,
    getSearchParams
  }
}